import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import {jwtstore} from "./JWTStore";
import {frontendService} from "../common/FrontendUtils";
import jwtDecode, {JwtPayload} from "jwt-decode";

export abstract class AbstractApiService {
    public readonly client: AxiosInstance;

    constructor() {
        this.client = axios.create();
    }

    public buildJWTAuthAxiosConfig(configBuilder: (jwt: string) => AxiosRequestConfig = jwt => ({headers: {Authorization: 'JWT ' + jwt}})) {
        const atlassianJwt = jwtstore.jwt;
        if (atlassianJwt === '') {
            console.warn(`Could not get JWT from URL ${window.location}! Backend will not accept occurring requests.`);
        }

        this.checkToken(atlassianJwt);

        const configWithJwtInformation = configBuilder(atlassianJwt);

        const url = new URL(window.location as any);
        const tenantKey = url.searchParams.get("tenantKey");

        if (!tenantKey) {
            return configWithJwtInformation;
        }

        return {params: {tenantKey}, ...configWithJwtInformation};
    }

    private checkToken(atlassianJwt: string) {
        if (atlassianJwt) {
            const decoded = jwtDecode<JwtPayload>(atlassianJwt);
            let exp = decoded.exp;
            let now = new Date().getTime() / 1000;
            if (exp && now > exp) {
                frontendService.sessionIsExpired();
            }
        }
    }
}
